import React, { useEffect, useRef } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import about1 from '../assets/about/about-section-1.jpg';
import about2 from '../assets/about/about-section-2.jpg';
import about3 from '../assets/about/about-section3.png';
import doc from '../assets/about/board/doc.jpg';
import serry from '../assets/about/board/serry.jpg';
import amr from '../assets/about/board/amr.jpg';
import noha from '../assets/about/board/noha.jpg';

const members = [
  { name: 'Dr. Tamer Tammam', img: doc, description: "Founder and Chairman" },
  { name: 'Amr El-Feki', img: amr, description: "Co-founder" },
  { name: 'Mohamed Serry', img: serry, description: "Board Member" },
  { name: 'Noha Saad', img: noha, description: "Executive Board Member" }];

const list = [
  "Renowned Educational Partnerships: Collaborating with leading institutions such as Uppingham School, and Moon Hall to ensure global education standards.",
  "Excellence in Sports: Strategic alliances with world-class sports organizations, including Chelsea FC, Rafa Nadal Academy, and the NBA, to offer elite extracurricular opportunities.",
  "Proven Execution: A strong track record of delivering premium educational projects like Uppingham Cairo, reflecting our ability to execute ambitious plans with precision."];

const About = () => {
  const scrollContainerRef = useRef(null);
  useEffect(() => {AOS.init({duration: 1000, easing: 'ease-in-out', once: true,});
  const scrollContainer = scrollContainerRef.current;
  let isScrolling;

    if (scrollContainer) {
      const handleScroll = () => {
      scrollContainer.classList.add("scrolling");
      clearTimeout(isScrolling);
      isScrolling = setTimeout(() => {scrollContainer.classList.remove("scrolling");}, 500);};
      scrollContainer.addEventListener("scroll", handleScroll);
      return () => {scrollContainer.removeEventListener("scroll", handleScroll);};}}, []);

  return (
    <div className="w-full px-0">
      
      {/* Section 1 */}
      <div className="w-full" data-aos="fade-up">
      <div className="w-full h-full grid md:grid-cols-[80%_20%] grid-cols-[100%_0%]">
      <div className="bg-blue text-white flex flex-col items-start justify-center text-left p-8 md:p-12 md:pr-44 space-y-2">
      <p className="font-bold font-tenor text-white uppercase text-2xl">about us</p>
      <p className="font-bold font-tenor text-green uppercase text-2xl">who we are</p>
      <p className='font-tenor text-white text-sm md:text-base'>Established in 2018, New Era Education is a pioneering force in educational management and development. Our mission is to deliver world-class, innovative educational experiences that redefine standards in the region.</p></div>


      {/* Image Section */}
      <div className="text-white items-center justify-center h-full hidden md:flex" data-aos="fade-left">
      <img src={about1} alt="About Us" className="h-full w-full object-cover" /></div></div></div>

      {/* Section 2 */}
      <div className="w-full h-[60vh] relative" data-aos="fade-up">
      <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center space-y-4 md:space-y-6 max-w-full overflow-hidden">
      <p className="font-bold font-tenor text-green uppercase text-2xl">Vision:</p>
      <p className="font-tenor text-white text-sm md:text-base break-words max-w-[90%] sm:max-w-[70%]">Redefining premium education by combining academic excellence, innovation, and holistic development.</p>
      <p className="font-bold font-tenor text-green uppercase text-2xl">Mission:</p>
      <p className="font-tenor text-white text-sm md:text-base break-words max-w-[90%] sm:max-w-[70%]">Delivering world-class, holistic education experiences that prepare students to excel globally while contributing to society.</p></div>
      
      {/* Background Image */}
      <img src={about2} alt="" className="w-full h-full object-cover" /></div>

      {/* Section 3 */}
      <div className="w-full" data-aos="fade-up"><div className="flex flex-row bg-white overflow-hidden font-tenor relative">
      <div className="w-full p-8 md:p-12 my-auto md:pr-[30%]">
      <p className="text-2xl font-bold uppercase text-green">Our Unique Value Proposition:</p>
      <ol className="mt-6 space-y-6 md:text-base text-sm" data-aos="fade-right">
      {list.map((item, index) => (
      <li key={index} className="relative pl-6 text-blue">
      <span className="absolute left-0 top-0 text-green">➜</span>{item}</li>))}</ol></div>
    
      <div className="hidden md:flex absolute inset-y-0 py-0 right-0 w-1/3" data-aos="fade-left">
      <img src={about3} alt="" className="h-full w-full object-fill" /></div></div></div>


      {/* Board Members */}
      <div className="p-8 md:p-12 w-full" data-aos="fade-up">
      <p className="uppercase text-2xl font-bold font-tenor text-center text-green">Board Members</p>
      <p className="md:text-base text-sm font-bold font-tenor text-center text-blue">Our board members share extensive experience in diverse industries.</p>

      <div className=" flex justify-center md:mt-4 mt-2">
      <div ref={scrollContainerRef}  className="overflow-x-auto flex scrollbar-thin scrollbar-track-transparent custom-scrollbar-board md:p-4 pb-8 pt-4">
      <div className="flex gap-4 mx-auto">
        {members.map((member, index) => (
          <div key={index} className="flex flex-col items-center flex-shrink-0 w-40" data-aos="zoom-in">
          <div className="w-40 h-40 overflow-hidden rounded-lg shadow-lg">
          <img src={member.img} alt={member.name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-200" /></div>
          <p className="font-bold text-sm md:text-base text-blue text-center mt-2 font-tenor">{member.name}</p>
          <p className="text-xs text-blue text-center font-tenor">{member.description}</p></div>))}</div></div></div>
          </div></div>);};

export default About;
